import { render } from "./DialogueComponent.vue?vue&type=template&id=d4f58f2e"
import script from "./DialogueComponent.vue?vue&type=script&lang=js"
export * from "./DialogueComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__